import { useState } from "react";
import { CalendarDays, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const toIso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export function DatePicker({ value, onChange, placeholder = "Pick a date", testId, fromToday = false }) {
  const [open, setOpen] = useState(false);
  const date = value ? new Date(`${value}T00:00:00`) : undefined;
  const today = new Date(); today.setHours(0, 0, 0, 0);
  return (
    <div className="flex items-center gap-1">
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button type="button" variant="outline" data-testid={testId} className={`w-full justify-start font-normal ${date ? "text-ink" : "text-ink-3"}`}>
            <CalendarDays className="mr-2 h-4 w-4 text-aqua" />{date ? date.toLocaleDateString(undefined, { day: "numeric", month: "long", year: "numeric" }) : placeholder}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar mode="single" selected={date} defaultMonth={date} disabled={fromToday ? { before: today } : undefined}
            onSelect={(d) => { onChange(d ? toIso(d) : ""); setOpen(false); }} initialFocus />
        </PopoverContent>
      </Popover>
      {value && <Button type="button" size="icon" variant="ghost" data-testid={`${testId}-clear`} onClick={() => onChange("")} aria-label="Clear date"><X className="h-4 w-4" /></Button>}
    </div>
  );
}
